/**
 * unreadySections.js -- turn the API's `unready_tabs` into editor sections.
 *
 * The Stores list and Review & Launch both need to name WHAT keeps a store
 * from opening (Bug Backlog #355). The API reports the legacy editor TAB
 * keys behind a False `is_ready` (`getCampaignList` / `getCampaignById`
 * `unready_tabs`); this maps them onto the nested-route sections the editor
 * is organised by, so every surface says the same section names.
 */
import { OLD_TAB_TO_SECTION, SECTION_META } from "./sectionRoutes";

/** `unready_tabs` entry for a readiness check that itself broke (API side). */
export const READINESS_ERROR_TAB = "readiness_error";

/**
 * The distinct editor sections behind `tabs`, in tab order, as
 * `[{ id, title }]`. Tabs that resolve to no section (the retired
 * fulfillment/locations/orders tabs, the readiness-error marker) are
 * dropped: there is nothing to link to.
 */
export function unreadySections(tabs) {
  const seen = new Set();
  const out = [];
  for (const tab of Array.isArray(tabs) ? tabs : []) {
    const id = OLD_TAB_TO_SECTION[tab];
    if (!id || seen.has(id)) continue;
    const meta = SECTION_META.find((s) => s.id === id);
    if (!meta) continue;
    seen.add(id);
    out.push({ id, title: meta.title });
  }
  return out;
}

/** True when the API says the readiness check itself failed. */
export function readinessCheckFailed(tabs) {
  return Array.isArray(tabs) && tabs.includes(READINESS_ERROR_TAB);
}
